import React, { useMemo } from 'react';
import { OrderedListToNumberedList } from './generic/OrderedListToNumberedList';
import { ParseListsFromTextFile } from '../utils/file-parsers';
import { useReadTextFileRaw } from '../utils/file-reader';

const GwenFullListText = require('../source-data/GwenFullList.txt');

export const GwenFullList = () => {
    const data = useReadTextFileRaw(GwenFullListText);
    // Use the first parsed list for the full list
    const parsedLists = useMemo(() => ParseListsFromTextFile(data), [data]);
    return <OrderedListToNumberedList data={parsedLists[0]} filterReplays={false} note={null} />;
};
